export const cashVersion = 'HCRLAKRYEX';